import { EnvironmentProviders, Provider } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ReportsComponentsEffects } from './components/components.effects';
import { ReportsComponentsHttpClient } from './components/components.http-client';
import {
  ReportsComponentsNamespace,
  ReportsComponentsReducer,
} from './components/components.store';
import { reportsStoreFeatureName } from './consts';
import { ReportsDashboardTemplatesEffects } from './dashboard-templates/dashboard-templates.effects';
import { ReportsDashboardTemplatesHttpClient } from './dashboard-templates/dashboard-templates.http-client';
import {
  ReportsDashboardTemplatesNamespace,
  ReportsDashboardTemplatesReducer,
} from './dashboard-templates/dashboard-templates.store';
import { ReportsDashboardsEffects } from './dashboards/dashboards.effects';
import { ReportsDashboardsHttpClient } from './dashboards/dashboards.http-client';
import {
  ReportsDashboardsNamespace,
  ReportsDashboardsReducer,
} from './dashboards/dashboards.store';
import { ReportsDetailsHttpClientBase } from './details/details.http-client';
import { ReportsLibraryComponentsEffects } from './library-components/library-components.effects';
import { ReportsLibraryComponentsHttpClient } from './library-components/library-components.http-client';
import {
  ReportsLibraryComponentsNamespace,
  ReportsLibraryComponentsReducer,
} from './library-components/library-components.store';
import { referenceReducer } from './meta-reducer';
import { ReportsMetricsEffects } from './metrics/metrics.effects';
import { ReportsMetricsHttpClient } from './metrics/metrics.http-client';
import { ReportsMetricsNamespace, ReportsMetricsReducer } from './metrics/metrics.store';
import { ReportsResultsEffects } from './results/results.effects';
import { ReportsResultsHttpClient } from './results/results.http-client';
import { ReportsResultsNamespace, ReportsResultsReducer } from './results/results.store';

const reportsState = provideState(
  reportsStoreFeatureName,
  {
    [ReportsComponentsNamespace]: ReportsComponentsReducer,
    [ReportsDashboardsNamespace]: ReportsDashboardsReducer,
    [ReportsMetricsNamespace]: ReportsMetricsReducer,
    [ReportsResultsNamespace]: ReportsResultsReducer,
    [ReportsLibraryComponentsNamespace]: ReportsLibraryComponentsReducer,
    [ReportsDashboardTemplatesNamespace]: ReportsDashboardTemplatesReducer,
  },
  {
    metaReducers: [referenceReducer],
  },
);

const reportsEffects = provideEffects([
  ReportsComponentsEffects,
  ReportsDashboardsEffects,
  ReportsMetricsEffects,
  ReportsResultsEffects,
  ReportsLibraryComponentsEffects,
  ReportsDashboardTemplatesEffects,
]);

export const provideCoreReportsData = (): Array<EnvironmentProviders | Provider> => [
  ReportsComponentsHttpClient,
  ReportsDashboardsHttpClient,
  ReportsDetailsHttpClientBase,
  ReportsMetricsHttpClient,
  ReportsResultsHttpClient,
  ReportsDashboardTemplatesHttpClient,
  ReportsLibraryComponentsHttpClient,
  reportsState,
  reportsEffects,
];
